import { get } from 'lodash';
import qs from 'query-string';
const FEATURE_FLAG_HIDE_STORE_SEE_ON_MAP_LINK = 'hideStoreSeeOnMapLink';
export default function getStoreMapLink(centre, store) {
  const {
    slug,
    legacyIdentifier
  } = store;
  const entryId = store.sys.id;
  const featureFlags = get(centre, 'featureFlags') || [];
  const hideStoreSeeOnMapLink = featureFlags.some(flag => flag.feature === FEATURE_FLAG_HIDE_STORE_SEE_ON_MAP_LINK && flag.value === 'true');
  const centreMapPath = "/".concat(centre.slug, "/centre-map/").concat(legacyIdentifier, "/").concat(slug);
  const storeMapLink = hideStoreSeeOnMapLink ? null : qs.stringifyUrl({
    url: centreMapPath,
    query: {
      entryId
    }
  });
  return storeMapLink;
}